import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getLoanKeys = async (dataOrigen, refrescar, api, token, body, config) => {
  
  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.keyloan.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate) {
    const response = await axios(configws)
    data = { keyloan: base64ToString(response) }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.keyloan.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(keyloan => {

      const closureStatusObj = {
        RETURNED: 'Devuelto',
        LOANED  : 'Prestada'
      }

      return (
        (
          keyloan.keyloan_datetime.toLowerCase().includes(queryLowered) ||
          keyloan.recieve_executive_id.toLowerCase().includes(queryLowered) ||
          closureStatusObj[keyloan.loan_status].toLowerCase().includes(queryLowered) ||
          keyloan.loan_executive_name.toLowerCase().includes(queryLowered) ||
          keyloan.loan_executive_id.toLowerCase().includes(queryLowered) ||
          keyloan.property_internal_key.toLowerCase().includes(queryLowered) 
        )
      )
  })

  return [
    200,
    {
      allData: data.keyloan,
      total: filteredData.length,
      datakeyloan: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of keyloan
// ------------------------------------------------

let dataKeyloan = JSON.parse(localStorage.getItem("dataKeyloan")) || { keyloan: [], startDate: '', endDate: '', property_internal_key: ''}

mock.onGet('/apps/loankey').reply(async config => {

  const user = getUserData()
  if (config.reset) {
    dataKeyloan = { keyloan: [], startDate: '', endDate: '', property_internal_key: ''}
  }

  const body = {
    date_from:             config.startDate,
    date_to:               config.endDate,
    property_internal_key: config.property_internal_key,
    office_id:             user.usercoc.office_id
  }

  const result = await getLoanKeys(dataKeyloan, 1, GetApiCOC('keyloan'), user.token, body, config)

  dataKeyloan = { keyloan: result[1].allData, startDate: config.startDate, endDate: config.endDate, property_internal_key:config.property_internal_key }

  localStorage.setItem("dataKeyloan", JSON.stringify(dataKeyloan))

  return result
})

// ------------------------------------------------
// Post: Add keyloan
// ------------------------------------------------
mock.onPost(/\/api\/keyloan\/\d+/).reply(async config => {

  const body = JSON.parse(config.data)

  const configws = {
    method: 'post',
    url:    GetApiCOC('keyloan'),
    headers: { 
      Accept:'application/json'
    },
    params: body
  }

  const response = await axios(configws)

  return [200, response.data]
})


// ------------------------------------------------
// Put: Add equipmentsloan
// ------------------------------------------------
